// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/en"
import GenericContent from "src/components/pages/GenericContent/GenericContent"

const GenericContentPageEn = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `genericContentPage.sections`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.genericContentPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <GenericContent sections={sections} />
    </Layout>
  )
}

export default GenericContentPageEn

export const query = graphql`
  query GenericContentPageEnQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "en" }) {
      ...topNavContent
    }

    genericContentPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    bottomNav: strapiBottomNav(locale: { eq: "en" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "en" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
